<template>
	<div>
		<div class="row">
			<div class="col-6 mb-4">
				<h1>{{ $t("tests") }}</h1>
			</div>
			<div class="col-6 d-lg-none mb-4">
				<div class="float-right">
					<router-link class="btn btn-secondary mr-2" to="/tests/viewall" v-if="canViewAllTests">{{ $t('view-all') }}</router-link>
					<router-link to="/tests/new" class="btn btn-primary">{{
						$t("new-test")
					}}</router-link>
				</div>
			</div>
			<div class="d-none d-lg-inline col-6">
				<div class="float-right">
					<router-link class="btn btn-secondary mr-2" to="/tests/viewall" v-if="canViewAllTests">{{ $t('view-all') }}</router-link>
					<router-link
						to="/tests/new"
						data-cy="new-test-button"
						class="float-right btn btn-primary"
						>{{ $t("new-test") }}</router-link
					>
				</div>
				<!-- <input
					type="search"
					:placeholder="$t('search-tests-ellipses')"
					class="block float-right mr-4 form-control inline w-auto"
					:value="searchTerm"
					@input="searchTerm = $event.target.value"
					@keyup="searchTermChange"
					@search="searchTermChange"
				/> -->
			</div>
			<div class="col-12 d-lg-none mb-4">
				<!-- <input
					type="search"
					:placeholder="$t('search-tests-ellipses')"
					class="block w-full form-control"
					:value="searchTerm"
					@input="searchTerm = $event.target.value"
					@keyup="searchTermChange"
					@search="searchTermChange"
				/> -->
			</div>
		</div>

		<div class="row" v-if="error">
			<div class="col-12">
				<div class="card" style="width: 18rem; margin: 40px auto 0;" v-if="error">
					<div class="card-body text-center">
						<b-icon
							icon="x-circle-fill"
							class="text-danger mb-2"
							style="font-size: 1.5rem"
						/>
						<h5 class="card-title capitalise">{{ $t("error") }}</h5>
						<p class="card-text">
							{{ $t("problem-loading-tests") }}
						</p>
						<button class="btn btn-primary" @click="getCompetencyTestSessions">
							{{ $t('load') }}
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="row" v-else>
			<div
				class="col-12"
				:class="{ 'col-lg-8': isTeacher, 'col-lg-4 order-lg-4': !isTeacher }"
			>
				<div class="list-group border-radius-2 no-border mb-8" v-if="loading">
					<div class="list-group-item clearfix" v-for="x in 10" :key="x">
						<div class="float-left">
							<div class="skeleton midnight h20 w200 mb-3"></div>
							<div class="skeleton midnight h20 w50"></div>
						</div>
						<div class="float-right">
							<div class="skeleton midnight h20 w200"></div>
						</div>
					</div>
				</div>
				<div class="list-group border-radius-2 no-border mb-8" v-else>
					<WidgetHeader link="/tests/viewall/actionrequired">{{
						isTeacher ? $t("marking-required") : $t("awaiting-marking")
					}}</WidgetHeader>

					<CompetencyTestSessionItem
					v-for="result in markingRequired"
					:item="result"
					@swipeLeftItem="swipeLeftItem"
					@swipeRightItem="swipeRightItem"
					@contextMenuItem="contextMenuItem"
					:swipedLeftItem="swipedLeftItem"
					@removeItem="removeItem"
					:key="result.CompetencyTestSessionID"
					/>
				</div>
			</div>

			<div
				class="col-12"
				:class="{ 'col-lg-4': isTeacher, 'col-lg-8 order-lg-1': !isTeacher }"
			>
				<div class="list-group border-radius-2 no-border mb-8" v-if="loading">
					<div class="list-group-item clearfix" v-for="x in 10" :key="x">
						<div class="float-left">
							<div class="skeleton midnight h20 w200 mb-3"></div>
							<div class="skeleton midnight h20 w50"></div>
						</div>
						<div class="float-right">
							<div class="skeleton midnight h20 w200"></div>
						</div>
					</div>
				</div>

				<div class="list-group border-radius-2 no-border mb-8" v-else>

					<WidgetHeader link="/tests/viewall/completed">{{ $t("completed-tests") }}</WidgetHeader>

					<CompetencyTestSessionItem
					v-for="result in marked"
					:item="result"
					@swipeLeftItem="swipeLeftItem"
					@swipeRightItem="swipeRightItem"
					@contextMenuItem="contextMenuItem"
					:swipedLeftItem="swipedLeftItem"
					@removeItem="removeItem"
					:key="result.CompetencyTestSessionID"
					/>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import WidgetHeader from "src/components/widgets/WidgetHeader";
//import LabelIndicator from "src/components/LabelIndicator";
import CompetencyTestSessionItem from "src/components/CompetencyTestSessionItem";

export default {
	components: {
		WidgetHeader,
		//LabelIndicator,
		CompetencyTestSessionItem
	},
	data: function() {
		return {
			marked: [],
			markingRequired: [],
			loading: false,
			error: false,
			swipedLeftItem: null
		};
	},
	mounted() {
		// api call here
		// this.results = testsTeacher;
		this.getCompetencyTestSessions();
	},
	methods: {
		swipeLeftItem(item) {
			this.swipedLeftItem = item;
		},
		swipeRightItem(item) {
			if(this.swipedLeftItem && item.CompetencyTestSessionID == this.swipedLeftItem.CompetencyTestSessionID) {
				this.swipedLeftItem = null;
			}
		},
		contextMenuItem(item) {
			if(this.swipedLeftItem && item.CompetencyTestSessionID == this.swipedLeftItem.CompetencyTestSessionID) {
				this.swipedLeftItem = null;
			} else {
				this.swipedLeftItem = item;
			}
		},
		removeItem(/*item*/) {
			this.getCompetencyTestSessions();
		},
		getCompetencyTestSessions() {
			this.loading = true;
			this.error = false;

			var data = {
				marked: true
			}
			if(this.isTeacher){
				data.teacher = [{
					id: this.$UserSession.getValue('id')
				}]
			}
			this.$cfetch(`${this.$settings.APIBaseURL}/competencytests/session/list`, {
				data: data,
				method: 'post'
			})
			.then(json => {
				if (json.status.toLowerCase() === "success") {
					this.marked = json.results;
					this.loading = false;
				} else {
					this.error = true;
					this.loading = false;
				}
			})
			.catch(error => {
				this.$log.error.call(this, error);
				this.loading = false;
				this.error = true;
			});

			data.marked = false;
			this.$cfetch(`${this.$settings.APIBaseURL}/competencytests/session/list`, {
				data,
				method: 'post'
			})
			.then(json => {
				if (json.status.toLowerCase() === "success") {
					this.markingRequired = json.results;
					this.loading = false;
				} else {
					this.error = true;
					this.loading = false;
				}
			})
			.catch(error => {
				this.$log.error.call(this, error);
				this.loading = false;
				this.error = true;
			});
		}
	},
	computed: {
		isTeacher: function() {
			return this.$UserSession.hasPriv.call(this, "APP_TEACHER");
		},
		isStudent: function() {
			return this.$UserSession.hasPriv.call(this, "APP_STUDENT");
		},
		canViewAllTests() {
			return this.$UserSession.hasPriv.call(this, "VIEW_ALLTESTS");
		}
	}
};
</script>
